export const config = {
  title: "Mirimar Real Estate & Investments, LLC | Cape Coral, FL",
  meta: {
    description:
      "Mirimar Real Estate & Investments, LLC is your trusted partner in buying, selling, and investing in real estate in Cape Coral, FL. Led by expert agent Miriam Ruiz.",
    keywords: [
      "Cape Coral real estate",
      "Miriam Ruiz homes",
      "Mirimar Real Estate",
      "Cape Coral property investment",
      "Florida real estate agency"
    ],
    author: "Mirimar Real Estate & Investments, LLC",
    canonicalUrl: "https://www.miriamruizhomes.com/",
  },
  sections: {
    header: {
      businessName: "Mirimar Real Estate & Investments, LLC",
    },
    sectionB: {
      heroTitle: "Cape Coral Real Estate Experts",
      heroSubtitle:
        "Find your dream home or sell with confidence in Cape Coral, FL",
      learnAboutText: "Contact Miriam Today",
      phoneNumber: "2392924018",
      phoneLabel: "(239) 292-4018",
      heroBackgroundImage:
        "https://media.istockphoto.com/id/2181067644/photo/aerial-drone-view-of-brick-veneer-town-houses-in-melbourne-northern-suburb-victoria-australian.jpg?s=612x612&w=0&k=20&c=WmtelVadMl2SH6HZyHM8T1L-29ZyhWjTbRyk_NCyDWs=",
      cardData: [
        {
          title: "Home Buying",
          description: "Get personalized help to find and close on your next home.",
        },
        {
          title: "Home Selling",
          description: "Expert market advice to get the most value for your property.",
        },
        {
          title: "Investment Properties",
          description: "Explore profitable real estate investment opportunities.",
        },
      ],
      description:
        "Miriam Ruiz is a real estate expert in Cape Coral, FL. Whether you're buying, selling, or investing, Mirimar Real Estate & Investments, LLC offers expert guidance and care throughout the process.",
    },
    sectionC: {
      servicesTitle: "Our Services",
      servicesDescription:
        "Whether you're relocating, investing, or selling, we provide personalized solutions to meet your real estate goals.",
      cards: [
        {
          title: "Property Listings",
          description: "Curated homes and properties ready for you to explore.",
          imageSrc:
            "https://media.istockphoto.com/id/2152639722/photo/teamwork-in-real-estate-business-people-meeting-together-about-real-estate-working-as-a.jpg?s=612x612&w=0&k=20&c=DDYLw3EFRxODJJO6YN6Yz2-u9jq3UhFGFcwSfVd4ChY=",
          imageAlt: "Cape Coral property listings",
        },
        {
          title: "Home Evaluations",
          description:
            "Get expert assessments on your property value in today’s market.",
          imageSrc:
            "https://media.istockphoto.com/id/1642302573/photo/the-model-home-was-delivered-to-the-customer-by-a-real-estate-agent-home-insurance-trading.jpg?s=612x612&w=0&k=20&c=1pdIoY9poub8eTfQY6W5V084t_9tRmc3e_0mtADnFwQ=",
          imageAlt: "Real estate evaluation",
        },
        {
          title: "Relocation Assistance",
          description: "Supporting you with seamless relocation to SW Florida.",
          imageSrc:
            "https://media.istockphoto.com/id/1136917684/photo/businessman-signing-agreement-contract-with-his-partner.jpg?s=612x612&w=0&k=20&c=G7-aGyyG5GlpJvu92WdJAweO8LPEnwE8DsVtxWzKuck=",
          imageAlt: "Cape Coral relocation services",
        },
      ],
      otherServicesTitle: "Why Choose Us",
      otherServicesList: [
        "Local Cape Coral Expertise",
        "Trusted by Buyers and Sellers",
        "Responsive Communication",
        "Personalized Real Estate Plans",
        "Strong Negotiation Skills",
      ],
    },
    sectionD: {
      aboutTitle: "About Miriam Ruiz",
      aboutImage: {
        src:
          "https://www.miriamruizhomes.com/wp-content/uploads/sites/25212/2025/09/MikasaTeam-450x450.png",
        alt: "Miriam Ruiz - Cape Coral Realtor",
      },
      aboutText: [
        "Miriam Ruiz is a dedicated Realtor® serving Cape Coral and surrounding Southwest Florida communities. With a passion for helping families and investors, she delivers professional guidance with a personal touch.",
        "Whether you're looking to buy your first home or expand your investment portfolio, Mirimar Real Estate & Investments, LLC is your go-to partner.",
      ],
    },
    sectionE: {
      profileImage: null,
      profileAlt: "Miriam Ruiz Realtor",
      businessName: "Mirimar Real Estate & Investments, LLC",
      contact: {
        phone: "2392924018",
        phoneLabel: "(239) 292-4018",
        email: "miriam@mirimarproperties.com",
        website: "https://www.miriamruizhomes.com/",
        address: "618 SW 3rd St #150, Cape Coral, FL 33991",
      },
      socialMedia: {},
    },
    sectionF: {
      address: "618 SW 3rd St #150, Cape Coral, FL 33991, USA",
      googleMapsEmbedUrl:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3522.5766303279127!2d-81.9854861!3d26.6381591!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88db2cc7f0c9b4d3%3A0xb7cd41ac122f4dc4!2s618%20SW%203rd%20St%20%23150%2C%20Cape%20Coral%2C%20FL%2033991%2C%20USA!5e0!3m2!1sen!2sph!4v1694716899999!5m2!1sen!2sph",
    },
  },
};

export default config;
